module.exports = "<ea-user-page company-filter-enabled=\"$ctrl.companyFilterEnabled\"></ea-user-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaUser/eaUserPage/eaUserPageModule.html
// module id = 1074
// module chunks = 12